import React from 'react';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { useDispatch, useSelector } from 'react-redux';
import { handleSnackbar } from '../uiSlice';
import type { RootState } from '@/app/store';

const Alert = React.forwardRef<HTMLDivElement, any>(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function SnackbarComponent() {
  const dispatch = useDispatch();
  const snackbar = useSelector((state: RootState) => state.ui.snackbar);

  const handleClose = (reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    dispatch(handleSnackbar({ open: false }));
  };

  return (
    <Snackbar
      open={snackbar.open}
      autoHideDuration={snackbar.autoHideDuration}
      onClose={() => handleClose()}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      sx={{ zIndex: 9999 }}
    >
      <Alert onClose={handleClose} severity={snackbar.severity}>
        {snackbar.message}
      </Alert>
    </Snackbar>
  );
}

export default SnackbarComponent;
